import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectMemberDetail } from 'features/member/reducer/memberDetailSlice';

import InformationTable from 'components/common/table/InformationTable';

import { InformationObject } from 'types/common/informationTable';
import CreateAnEmailVerificationLinkButton from 'components/member/memberListCell/CreateAnEmailVerificationLinkButton';
import { UnverifiedTextWrapper } from './GeneralInformation.styled';
import { getIntegratedAt, getStatus } from './utils';

const GeneralInformation = () => {
  const generalInformation = useSelector(selectMemberDetail);

  const {
    userid,
    connectNickName,
    closetUserName,
    email,
    status,
    verifyToken,
    marketingAgree,
    isIntegrated,
    integratedAt,
  } = generalInformation;

  const memberInformation: InformationObject[] = [
    {
      title: 'User ID',
      render: userid,
      titleWidth: '20%',
    },
    { title: 'Email', render: email, titleWidth: '20%' },
    {
      title: 'Name',
      render: `CLO-SET: ${closetUserName} / CONNECT: ${connectNickName}`,
      titleWidth: '20%',
    },
    { title: 'Status', render: getStatus(status), titleWidth: '20%' },
    {
      title: 'Email Verification',
      render:
        verifyToken === null ? (
          'Verified'
        ) : (
          <UnverifiedTextWrapper>
            <p>Unverified</p>
            <CreateAnEmailVerificationLinkButton userId={userid} />
          </UnverifiedTextWrapper>
        ),
      titleWidth: '20%',
    },
    { title: 'Marketing Agreement', render: marketingAgree ? 'Yes' : 'No', titleWidth: '20%' },
    {
      title: 'Integrated Account',
      render: isIntegrated ? `Yes ( UTC: ${getIntegratedAt(integratedAt)} )` : 'No',
      titleWidth: '20%',
    },
  ];

  return <InformationTable title={'[CLO-SET] General Information'} data={memberInformation} />;
};

export default GeneralInformation;
